import { render } from "./Intro.vue?vue&type=template&id=4f365373"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"
script.render = render

export default script